/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type EngineEnum = (typeof EngineEnum)[keyof typeof EngineEnum];

export const EngineEnum = {
  template: 'template',
  legacy: 'legacy',
  grooming: 'grooming',
} as const;
